export const events: IEvent[] = [
    {
        title: "2024 Manitoba Disc Golf Tour",
        tier: "XC",
        date: "Sat-Sun, October 5-6",
        location: "Stony Mountain Quarry",
        td: "Xavier Tomanek",
        url: "https://www.discgolfscene.com/tournaments/2024_Manitoba_Disc_Golf_Tour_2024/registration",
    },
]